const AGREEMENTS = 'agreements/2.0/agreements';
const AIA_CONNECTORS = 'aia-connectors/2.0/aia';
const AIS_CONNECTORS = 'ais-connectors/1.0';
const ATLAS = 'atlas-connectors/1.0';
const CALCULATIONS = 'travel-calculations/2.0';
const CAMUNDA_ORCH = 'camunda-orchestrations/1.0';
const CLAIMS = 'claims/1.0/claims';
const COMMUNICATIONS = 'communications/1.0';
const CONFIG = 'configurations/1.0';
const CONSENTS = 'consents/1.0/marketing-consents';
const CRG = 'crg/3.0';
const CUZK_CONNECTORS = 'cuzk-connectors/1.0';
const DEBTS = 'debts/1.0/debts';
const DISTRIBUTORS = 'distributors/2.0';
const DMS_CONNECTORS = 'dms-connectors/1.0';
const DOMAIN = 'KOMERCPOJ.CZ';
const EMAIL = 'mails/2.0';
const ENUMS = 'enums/2.0';
const ESCO = 'esco-connectors/1.0';
const EXCHANGE = 'exchange-rates/1.0';
const FINANCIALS = 'financials/1.0';
const FLAGS = 'feature-flags/1.0';
const FLOODZONES = 'floodzones/3.0';
const FOX_API = 'https://api.foxentry.com';
const FOX_TOKEN = 'pIhHHmmr0mteEzzad8OD';
const ISIR = 'isir-connectors/1.0';
const JOURNALS = 'journals/1.0';
const JSONS = 'jsons-storage/1.0';
const LOCKS = 'locks/1.0';
const LOGS = 'logs/1.0';
const MDS_DOCUMENTS = 'mds-documents/1.0';
const ODS_PARTIES = 'ods-parties/1.0';
const OMNI = 'omni-reports/1.0';
const PARTIES = 'parties/1.0';
const PAYMENT_GATEWAYS = 'payment-gateways/1.0';
const PAYOUT_REQUESTS = 'payout-requests/1.0';
const RAW_DATA = 'rawdata/1.0';
const STATISTICS = 'statistics/1.0/statistics';
const SVIPO = 'svipo/1.0';
const SYNC = 'sync/1.0';
const THIRD_PARTIES = 'third-parties/1.0/third-parties';
const USERS = 'users/2.0/users';
const USERS_INT = 'users-int/2.0/users';

export {
  AGREEMENTS,
  AIA_CONNECTORS,
  AIS_CONNECTORS,
  ATLAS,
  CALCULATIONS,
  CAMUNDA_ORCH,
  CLAIMS,
  COMMUNICATIONS,
  CONFIG,
  CONSENTS,
  CRG,
  CUZK_CONNECTORS,
  DEBTS,
  DISTRIBUTORS,
  DMS_CONNECTORS,
  DOMAIN,
  EMAIL,
  ENUMS,
  ESCO,
  EXCHANGE,
  FINANCIALS,
  FLAGS,
  FLOODZONES,
  FOX_API,
  FOX_TOKEN,
  ISIR,
  JOURNALS,
  JSONS,
  LOCKS,
  LOGS,
  MDS_DOCUMENTS,
  ODS_PARTIES,
  OMNI,
  PARTIES,
  PAYMENT_GATEWAYS,
  PAYOUT_REQUESTS,
  RAW_DATA,
  STATISTICS,
  SVIPO,
  SYNC,
  THIRD_PARTIES,
  USERS,
  USERS_INT,
};
